import { catchError, Observable, tap, throwError } from 'rxjs';
import { DecryptAesClientSide, EncryptAesClientSide } from '../encryption';
import { ExceptionsService } from '../services/utelize/general/exceptions-service';
import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { StorageService } from '../services/utelize/general/storage-service';
import { StorageValues } from '../consts';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(
    private exceptionsService: ExceptionsService,
    private storageService   : StorageService,

    public  router: Router
  ) { }

  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    try {
      //CRN_20250516 - ssoToken MUST only be used on the first login attempt (Authentication), then the inviewToken will be used (Authorisation)
      let inviewToken: null | string | undefined=DecryptAesClientSide(this.storageService.getItem(StorageValues.encToken));
      let ssoToken   : null | string | undefined=DecryptAesClientSide(this.storageService.getItem(StorageValues.encSsoToken));

      if ((inviewToken && inviewToken.trim() != "") ||
          (ssoToken    && ssoToken.trim()    != "")) {
        request=request.clone({
            setHeaders: {
                Authorization: `Bearer ${ssoToken? ssoToken : inviewToken}`,
                TimeZone: 'UTC',
            },
        });
      }
      
      return next.handle(request)
      .pipe(
        tap((httpEvent: HttpEvent<any>) =>{
          
          if(httpEvent.type === 0)
              return;
          
          if (httpEvent instanceof HttpResponse) {
            //let keys=httpEvent.headers.keys()

            if(httpEvent.headers.has('authorization')) {
              this.storageService.setItem(StorageValues.encToken, EncryptAesClientSide(<string>httpEvent.headers.get('authorization')?.replaceAll("Bearer", "").trim()));
            }
          }
        }),
        catchError((error) => {
          if (error.status === 401) {
            this.router.navigate(['/auth/login']);
          }

          return throwError(() => error);
        })
      );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return throwError(() => e);
    }
  }
}
